import React, { useRef, useEffect, useState } from 'react';
import { connect } from "react-redux";
import { get } from 'lodash';
import useVideoContext from '../hooks/useVideoContext';
import { MUTE_AUDIO, TURNOFF_VIDEO } from '../constants';
import { firstNameFirst, formatPhoneNumber } from "../../../../helpers/formatting";
import { Logger } from '../utils';
import { Participant } from 'twilio-video';

const MainParticipantOverlay = ({ appointmentDetails, identity, participantName, participantType, emailOrPhone, employeeType, isAudioEnabled, isVideoEnabled, toggle, target, setShowRemoveGuestModal }) => {
    const overlayRef = useRef();
    const { room } = useVideoContext();
    const [localDataTrackPublication] = [...room.localParticipant.dataTracks.values()];
    let participantTypeLabel = participantType || employeeType;

    if (participantType) {
        participantType = participantType.toLowerCase();
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
            if (toggle) {
                toggle();
            }
        };
    }, []);

    const handleClick = e => {
        if (overlayRef && overlayRef.current && overlayRef.current.contains(e.target)) {
            return false;
        }
        // Hide popover when click outside expect target element
        if (get(e, 'target.id') !== target && toggle)
            toggle();
    };

    const onVideoClick = (e) => {
        e.stopPropagation();
        if (localDataTrackPublication) {
            localDataTrackPublication.track.send(JSON.stringify({ eventName: TURNOFF_VIDEO, identity }));
            Logger("UI.Twilio.DataTrack.Send.TurnOffVideo", new Date(), { eventName: TURNOFF_VIDEO, identity });
        }
    }

    const onMicClick = (e) => {
        e.stopPropagation();
        if (localDataTrackPublication) {
            localDataTrackPublication.track.send(JSON.stringify({ eventName: MUTE_AUDIO, identity }));
            Logger("UI.Twilio.DataTrack.Send.MuteAudio", new Date(), { eventName: MUTE_AUDIO, identity });
        }
    }

    const onLogoutClick = (e) => {
        e.stopPropagation();
        setShowRemoveGuestModal(true);
    }

    return (<React.Fragment>
        <div className="main-participant-overlay" ref={overlayRef}>
            <div className="header-text">
                <span>{participantTypeLabel ? participantTypeLabel.charAt(0).toUpperCase() + participantTypeLabel.slice(1).toLowerCase() : "Participant"} Management</span>
                <button type="button" className="btn btn-icon-only" onClick={ toggle }><span className="icon-close"></span></button>
            </div>
            <div className="main-participant-overlay__user">
                <div className="details-icon-prepend">
                    <div className="icon-col">
                        <span className="icon-user" />
                    </div>
                    <div className="details-col">
                        {participantName && (participantType === 'patient' ? participantName : firstNameFirst(participantName))}
                    </div>
                </div>
                {(participantType === "patient" || participantType === "guest") &&
                    <div className="main-participant-overlay__user--mobile">
                        {participantType === "patient"
                            ? <div>
                                {appointmentDetails && appointmentDetails.patientDOB &&
                                    <div className="appt-dob">
                                        <div className="appt-detail-title">Patient Date of Birth</div>
                                        <div className="appt-detail-text">{appointmentDetails.patientDOB}</div>
                                    </div>
                                }
                                {appointmentDetails && <div className="appt-reason">
                                    <div className="appt-detail-title">Reason for Visit</div>
                                    <div className="appt-detail-text">{appointmentDetails.reasonForVisit
                                        ? <ShowMoreOrLess text={appointmentDetails.reasonForVisit} minTextLength={65} />
                                        : <span className="no-data-text">No comment</span>
                                    }</div>
                                </div>
                                }
                            </div>
                            : <>{emailOrPhone &&
                                <div className="details-icon-prepend">
                                    <div className="icon-col">
                                        <span className="icon-list-check" />
                                    </div>
                                    <div className="details-col">
                                        {emailOrPhone.indexOf('@') === -1 ? formatPhoneNumber(emailOrPhone) : emailOrPhone}
                                    </div>
                                </div>
                            }</>
                        }
                    </div>
                }
            </div>
            <div className="main-participant-overlay__actions">
                <div className={"action-item" + (!isVideoEnabled ? " disabled-style" : "")} disabled={!isVideoEnabled} onClick={onVideoClick} tabIndex="0">
                    <div className="details-icon-prepend">
                        <div className="icon-col">
                            <span className={isVideoEnabled ? "icon-camera" : "icon-camera-off"} />
                        </div>
                        <div className="details-col">
                            Turn off video
                    </div>
                    </div>
                </div>

                <div className={"action-item" + (!isAudioEnabled ? " disabled-style" : "")} disabled={!isAudioEnabled} onClick={onMicClick} tabIndex="0">
                    <div className="details-icon-prepend">
                        <div className="icon-col">
                            <span className={isAudioEnabled ? "icon-mic" : "icon-mic-off"} />
                        </div>
                        <div className="details-col">
                            Mute
                            </div>
                    </div>
                </div>

                {participantType === "guest" &&
                    <div className={`action-item separator`} onClick={onLogoutClick} tabIndex="0">
                        <div className="details-icon-prepend">
                            <div className="icon-col">
                                <span className="icon-kick-out" />
                            </div>
                            <div className="details-col">
                                Remove
                                </div>
                        </div>
                    </div>
                }
            </div>
        </div>
        <div className="twilio-video-backdrop" />
    </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    return {
        employeeType: state.domain.et
    };
};

export default connect(mapStateToProps, null)(MainParticipantOverlay);

const ShowMoreOrLess = ({ text, minTextLength }) => {
    const [showMore, setShowMore] = useState(false);
    minTextLength = minTextLength ? minTextLength : 150;

    return (
        <div>{!showMore
            ? <div>{!text || text.length <= (minTextLength + 1)
                ? text
                : <div>
                    {text.substr(0, minTextLength)}{'... '}
                    <button type="button" className="btn text-btn" onClick={() => setShowMore(true)}>
                        SEE MORE
                    </button>
                </div>
            }</div>
            : <div>
                {text}{' '}
                <button type="button" className="btn text-btn" onClick={() => setShowMore(false)}>
                    SEE LESS
                </button>
            </div>
        }</div>
    );
}